export default {
  voucher: {
    title: '嵯峨野トロッコ列車乗車票',
    info: {
      voucherNumber: 'チケット番号',
      date: '利用日',
      time: '発車時間',
      serviceName: '列車名',
      userNumber: '乗車人数',
      seat: '座席',
      agentName: '代理店名',
      agentSubGroupName: '営業所名',
      groupName: '団体名',
      groupNameValue: '{{groupName}}　様',
      tip: '特記事項',
      notice: '注意事項',
      total: '合計 ',
      people: '名',
      station: 'トロッコ',
      seatsTips: `
      詳細は下記座席表を参照願います`,
      noticeValue: `乗車当日は発車20分前までに手続きをお願いします。
        緊急の際は075-871-3997までご連絡をお願いします。
        トロッコ列車は全車指定席。
        全車禁煙です。
        `
    },
    qrCode: {
      title: '二次元バーコード \n（嵯峨野トロッコ業務用）',
      tip: 'チケットの利用方法',
      step1: 'STEP01',
      step1Tip: 'この乗車票を印刷する',
      step2: 'STEP02',
      step2Tip: '駅の窓口に発車20分前に受付を完了してください',
      step3: 'STEP03',
      step3Tip: '座席表を確認してお座り下さい'
    },
    carsTitle: '座席表',
    carsTip: '※座席番号が記載されているところが選択されている座席です。',
    carsDirectionDown: '← トロッコ亀岡方面',
    carsDirectionUp: 'トロッコ嵯峨方面 →',
    arrangementPattern: {
      carName: '車両',
      car1: '1号車',
      car2: '2号車',
      car3: '3号車',
      car4: '4号車',
      car5: 'リッチ号/5号車'
    }
  },
  invoice: {
    title: '請求書',
    paymentType: {
      PREPAID: '(クレジットカード支払い)',
      COUPON: '（船車券発行）',
      MONTHLY: '（銀行振込）',
      CASH: '現金',
      OTHER: 'その他'
    },
    info: {
      title: '{{agentName}} 御中',
      tip: '毎々格別のお引き立てを賜り、誠にありがとうございます。下記の通り、ご請求申し上げます。'
    },
    infoDate: {
      COUPON: 'お支払い期限',
      PREPAID: 'お支払い期限'
    },
    bill: {
      title: 'ご請求金額（税込）',
      people: '人数合計',
      groupType: '団体区分',
      date: '利用日',
      time: '乗車時刻',
      trainName: '列車名'
    },
    table: {
      allAmount: '総額 (1)+(2)（税込）',
      cancelAllAmount: '総額 (2)+(3)（税込）',
      total: '合計',
      allPaidAmount: 'お支払い済額',
      taxDiff: '税率区分',
      tax: '消費税',
      amount: '金額（税込）',
      memo: '備考'
    },
    tax: '消費税額',
    groupType: {
      NORMAL: '一般団体',
      SCHOOL: '学生団体'
    },
    taxDetail: '税金詳細',
    agent: {
      date: '発行日',
      invoiceId: '請求番号',
      corporateNumber: '登録番号',
      postalCode: '〒',
      address: '住所',
      phone: '電話',
      fax: 'FAX'
    }
  },
  seat: {
    wheelchairPair: {
      primaryTitle:
        'You have selected the wheelchair-accessible seat ({{seat}}).',
      supporterTitle:
        'You have selected the wheelchair companion seat ({{seat}}).',
      yes: 'Yes',
      cancel: 'Cancel',
      lead: 'Please review the following.',
      consideration:
        'This seat is reserved for customers using a wheelchair and those assisting them. We ask for your consideration.',
      contact:
        'For customers booking a wheelchair-accessible seat\nThere are a few things we need to confirm with you before boarding. Please read "For Customers with Disabilities" on our website or in your booking confirmation email, then contact us.',
      spaceFull:
        '* If the wheelchair spaces are fully booked, we will let you know on the payment screen. Thank you for your understanding.',
      continue: 'Do you want to continue with this selection?'
    },
    parenthesis: '({{text}})',
    header: {
      station: 'Please enter your purchase information.',
      seat: 'Please select the carriage and seat.',
      start: 'departure at {{time}}',
      confirm: 'You have specified the following seats.',
      orderConfirm: 'Seat Confirmation',
      orderConfirmTip:
        '* The seat will only be officially reserved after payment and booking are completed.'
    },
    button: {
      back: 'Back',
      next: 'Next'
    },
    selectSeatType: {
      title: 'Seat selection method',
      auto: 'Auto assignment',
      manual: 'Manual selection'
    },
    station: {
      date: 'Date',
      startStation: 'Departure station',
      endStation: 'Arrival station',
      startStationTip: 'Please select the departure station',
      endStationTip: 'Please select the arrival station'
    },
    hintType: {
      OUT_OF_AVAILABLE_TERM:
        'The sale begins one month before the boarding date. The selected date is invalid.',
      END_OF_SERVICE: 'The operation for today has concluded.'
    },
    train: {
      header: 'Please select the train.',
      emptySeat: 'Empty seat'
    },
    carriage: {
      carriage1: 'Car No.1',
      carriage2: 'Car No.2',
      carriage3: 'Car No.3',
      carriage4: 'Car No.4',
      carriage5: 'RichCar No.5',
      directionUpTitle: '↑ Toward Saga Torokko Station',
      directionDownTitle: '↑ Toward Kameoka Torokko Station'
    },
    baseCar: {
      front: "Driver's cab",
      entrance: 'Entrance'
    }
  },
  receipt: {
    title: '領収書',
    name: '御中',
    number: 'No.',
    issueData: '発行日',
    amountTips: '但、嵯峨野トロッコ利用料として\n上記正に領収いたしました。',
    price: '金額',
    priceUnit: '￥{{price}}',
    afterTax: '（税込）',
    afterTaxPrice: '税抜金額',
    taxPrice: '消費税等',
    issuer: `{{name}}\n〒{{postalCode}}\n{{address}}\n電話：{{phoneNumber}}`,
    chargeTips: '※内訳は請求書を参照願います。',
    tips: '＊A4縦に印刷し、下部の余白は切ってお使いください'
  },
  cancellationPolicy: {
    title: 'キャンセルポリシー'
  }
};
